import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { Provider as StoreProvider } from 'react-redux';
import reportWebVitals from './reportWebVitals';
import beforeInit from './beforeInit';
import Store from "./Store/index";
//import 'react-toastify/dist/ReactToastify.css';

import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './App.scss';
import './Firefox.scss';
import './investment.scss';
import './childModule.scss';
import './tenant.scss';
import '../node_modules/font-awesome/css/font-awesome.min.css';
import '../node_modules/jquery/dist/jquery.js';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js';
import './i18n';
import '../src/fonts/GothamLight.ttf';
import '../src/fonts/GothamMedium.ttf';
import '../src/fonts/GothamBook.ttf';
import '../src/fonts/GothamBold.ttf';
import * as constants from './Utils/constants';

const translations = sessionStorage.getItem(constants.LOCALSTORAGE.translations);
const lang = sessionStorage.getItem(constants.LOCALSTORAGE.lang);

beforeInit(translations, lang);




ReactDOM.render(
  <React.StrictMode>
    <StoreProvider store={Store}>
      <Suspense fallback={null}>
        <App />
      </Suspense>
    </StoreProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
reportWebVitals();